(() => {
  let queue = Promise.resolve();
  document.querySelectorAll('[data-coffee-form], [data-subscription-form]').forEach(form => {
    if (form.dataset.enhanced) return;
    form.dataset.enhanced = 'true';
    const card = form.closest('[data-coffee-card]');
    const variantInput = form.querySelector('[name="id"]');
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const hiddenPlan = form.querySelector('[name="selling_plan"]');
    const cadence = form.querySelector('[data-subscription-cadence]');
    const summary = form.querySelector('[data-subscription-summary]');
    const choice = form.querySelector('[data-subscription-choice]');
    const radios = [...form.querySelectorAll('[name="purchase-option"]')];
    const quantity = form.querySelector('[name="quantity"]');
    const formatLinks = card ? [] : [...document.querySelectorAll('.coffee-format-options a')];
    if (!card) {
      const params = new URL(location.href).searchParams;
      const purchase = params.get('purchase');
      if (purchase === 'subscription' || purchase === 'one-time') radios.forEach(r => { r.checked = r.value === purchase; });
      const frequency = params.get('frequency');
      if (frequency === 'weekly' || frequency === 'monthly') cadence.value = frequency;
      const amount = params.get('quantity');
      if (quantity && amount !== null) quantity.value = /^[1-9]\d*$/.test(amount) && Number.isSafeInteger(Number(amount)) ? amount : '1';
    }
    let busy = false, uncertain = false, selection;
    const sync = () => {
      const variant = [...form.querySelectorAll('[data-variant-id]')].find(v => v.dataset.variantId === variantInput.value);
      const subscribing = radios.some(r => r.value === 'subscription' && r.checked);
      const plans = variant ? [...variant.querySelectorAll('[data-plan-id]')] : [];
      const matches = plans.filter(p => p.dataset.cadence === cadence.value);
      const plan = matches.length === 1 ? matches[0] : null;
      selection = {variant, plan: subscribing ? plan : null, subscribing};
      if (choice) choice.hidden = false;
      radios.forEach(r => { r.disabled = busy || uncertain || (r.value === 'one-time' && variant?.dataset.requiresPlan === 'true'); });
      cadence.disabled = !subscribing || busy || uncertain;
      const frequency = form.querySelector('[data-subscription-frequency]');
      const disclosure = form.querySelector('[data-subscription-disclosure]');
      if (frequency) frequency.hidden = !subscribing;
      if (disclosure) disclosure.hidden = !subscribing;
      const subscriptionPrice = form.querySelector('[data-subscription-price]');
      if (subscriptionPrice) subscriptionPrice.textContent = plan?.dataset.price || '';
      [...cadence.options].forEach(o => { o.disabled = plans.filter(p => p.dataset.cadence === o.value).length !== 1; });
      hiddenPlan.disabled = !subscribing || !plan;
      hiddenPlan.value = subscribing && plan ? plan.dataset.planId : '';
      const oneTimePrice = form.querySelector('[data-one-time-price]');
      if (oneTimePrice) oneTimePrice.textContent = variant?.dataset.price || '';
      const valid = variant?.dataset.available === 'true' && (subscribing ? !!plan : variant?.dataset.requiresPlan !== 'true');
      button.disabled = busy || uncertain || !valid;
      const price = subscribing && plan ? plan.dataset.price : variant?.dataset.price;
      const priceNode = document.getElementById('variant-price');
      if (!card && priceNode && price) priceNode.textContent = price;
      summary.textContent = subscribing ? (plan ? plan.dataset.planName + ' \u2014 ' + plan.dataset.price + ' per bag, billed ' + cadence.value + ' until cancelled.' : 'This subscription frequency is unavailable for this coffee. Choose another frequency or one-time purchase.') : 'One-time purchase \u2014 ' + (variant?.dataset.price || '') + ' each. No recurring charges.';
      const option = variantInput.selectedOptions?.[0];
      if (card && option) card.querySelectorAll('[data-coffee-link]').forEach(link => { link.href = option.dataset.url; });
      if (!card) {
        const params = new URL(location.href);
        params.searchParams.set('purchase', subscribing ? 'subscription' : 'one-time');
        params.searchParams.set('frequency', cadence.value);
        if (quantity) params.searchParams.set('quantity', quantity.value);
        history.replaceState(history.state, '', params);
        formatLinks.forEach(link => {
          const url = new URL(link.href, location.href);
          ['purchase', 'frequency', 'quantity'].forEach(key => url.searchParams.set(key, params.searchParams.get(key)));
          const preview = params.searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          link.href = url.href;
        });
      }
      if (!busy && !uncertain && status) status.textContent = '';
      return valid;
    };
    form.addEventListener('change', sync);
    if (!card && quantity) quantity.addEventListener('input', sync);
    if (!card) window.addEventListener('pageshow', sync);
    sync();
    form.addEventListener('submit', event => {
      if (busy || uncertain || !sync()) { event.preventDefault(); return; }
      if (!card) return;
      event.preventDefault();
      const id = variantInput.value;
      const quantity = form.querySelector('[name="quantity"]').value;
      if (!/^\d+$/.test(quantity) || Number(quantity) < 1) { status.textContent = 'Choose a valid number of bags.'; return; }
      const plan = selection.plan;
      const grind = variantInput.selectedOptions[0].textContent.trim();
      const purchase = plan ? plan.dataset.cadence + ' subscription, ' + plan.dataset.price + ' per bag until cancelled' : 'one-time purchase, ' + selection.variant.dataset.price + ' each';
      const label = form.dataset.coffeeName + ' \u2014 ' + grind + ', 12 oz, ' + quantity + ' bag(s), ' + purchase;
      const body = new URLSearchParams({id, quantity});
      if (plan) body.set('selling_plan', plan.dataset.planId);
      busy = true;
      sync();
      button.textContent = 'ADDING\u2026';
      form.setAttribute('aria-busy', 'true');
      status.textContent = 'Adding ' + label + '\u2026';
      queue = queue.then(async () => {
        let confirmed = false;
        try {
          const response = await fetch(form.action + '.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/x-www-form-urlencoded',Accept:'application/json'},body:body.toString()});
          if (!response.ok && response.status < 500) {
            const error = await response.json();
            status.textContent = error.description || 'Could not add this coffee. Please try again.';
            return;
          }
          if (!response.ok) throw new Error('Unconfirmed addition');
          const item = await response.json();
          const returnedPlan = item.selling_plan_allocation?.selling_plan?.id;
          if (String(item.id) !== id || !item.quantity || (plan ? String(returnedPlan) !== plan.dataset.planId : !!returnedPlan)) throw new Error('Unconfirmed purchase option');
          confirmed = true;
          status.textContent = 'Added ' + label + ' to your bag.';
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
            if (!response.ok) throw new Error('Count unavailable');
            const cart = await response.json();
            if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid count');
            const count = document.getElementById('bag-count');
            if (count) count.textContent = String(cart.item_count);
          } catch { status.textContent += ' View your bag for the current total.'; }
        } catch {
          if (!confirmed) { uncertain = true; status.textContent = 'Could not confirm the purchase option. Check your bag before adding again.'; }
        } finally {
          busy = false;
          const message = status.textContent;
          sync();
          status.textContent = message;
          button.textContent = uncertain ? 'CHECK YOUR BAG' : 'ADD TO BAG';
          form.removeAttribute('aria-busy');
        }
      });
    });
  });
})();
